<template>
  <div>
    <ba-header activeModule="Colors"></ba-header>

    <ba-page-with-sidebar :title="'Colors'">

      <div slot="main" v-loading="loading">
        <h3 class="u-pt5 c-heading__page u-pb3">Colors</h3>
        <ba-color-picker v-for="color in colors"
                         :color="color"
                         :key="color.slug"
                         class="u-pt3 u-pb3 picker-border"
                         @updateColorSignal="updateColorSignal"></ba-color-picker>
      </div>

    </ba-page-with-sidebar>

  </div>
</template>

<script>
import {mapActions} from 'vuex'
import BaPageWithSidebar from '@/components/page-with-sidebar.component'
import BaColorPickerComponent from './ba-color-picker.component.vue'


export default {
  components: {
    BaPageWithSidebar,
    'ba-color-picker': BaColorPickerComponent,
  },
  data () {
    return {
      companyId: this.$route.params.companyId,
      colors: [],
      loading: false,
    }
  },
  methods: {
    ...mapActions('colors', ['loadColors', 'updateColor']),
    async updateColorSignal (payload) {
      this.loading = true

      await this.updateColor({
        companyId: this.companyId,
        colorSlug: payload.slug,
        newValue: payload.value
      })
      await this.loadColorsList()

      this.loading = false
    },
    async loadColorsList () {
      let colorsDict = (await this.loadColors(this.companyId)).data
      this.colors = Object.keys(colorsDict).map(slug => colorsDict[slug])
    }
  },
  computed: {},
  async mounted () {
    this.loading = true

    await this.loadColorsList()

    this.loading = false
  },
}
</script>
<style lang="scss">
  .picker-border {
     border-top: 3px solid #999999;
     width: 1100px;
  }
</style>
